import React, { Fragment, useEffect, useState } from 'react';
import Footer from '../Footer/Footer';
import Loader from '../../loader/Loader';
import PageSEO from '../Common/PageSEO';
import FAQ2 from '../FAQ/f2';
import FAQ3 from '../FAQ/f3';
import {
    FeatureHero,
    FeatureCtaButton,
    FeatureChain,
    FeatureSteps,
    FeatureSection,
    FeatureCta
} from '../Common/FeatureContent';
import { useLocale } from '../../localization/LocaleContext';
import { ROUTE_PATHS } from '../../localization/constants';

function HowItWorksMain(){
    const { t, toLocalizedPath, locale } = useLocale();
    const p = (key) => t(`resourcePages.howItWorks.${key}`);
    const w = (key) => t(`homeWorkflow.${key}`);

    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setLoader(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    if (!loader) {
        return <Loader/>;
    }

    const steps = [1, 2, 3, 4, 5].map((num) => ({
        title: w(`step${num}Title`),
        description: w(`step${num}Description`)
    }));

    return(
        <Fragment>
            <PageSEO title={p('metaTitle')} description={p('metaDescription')} path={ROUTE_PATHS.howItWorks} locale={locale} />

            <FeatureHero
                eyebrow={p('eyebrow')}
                title={p('heroTitle')}
                highlight={p('heroHighlight')}
                subtitle={p('heroSubtitle')}
                cta={<FeatureCtaButton to={toLocalizedPath('home')}>{p('heroCta')}</FeatureCtaButton>}
            />

            <FeatureSection alt title={p('stepsSectionTitle')} description={p('stepsSectionDescription')}>
                <FeatureChain steps={[w('chainCapture'), w('chainEstimate'), w('chainQuote'), w('chainInvoice'), w('chainPayment')]} />
                <div className="mt-40">
                    <FeatureSteps steps={steps} />
                </div>
            </FeatureSection>

            {/* Reuse relevant FAQ answers about invoices and estimates */}
            <FeatureSection title={p('faqSectionTitle')} description={p('faqSectionDescription')}>
                <FAQ2 />
                <FAQ3 />
            </FeatureSection>

            <FeatureCta
                title={p('ctaTitle')}
                description={p('ctaDescription')}
                ctaTo={toLocalizedPath('home')}
                ctaLabel={p('ctaButton')}
            />

            <Footer/>
        </Fragment>
    );
}

export default HowItWorksMain;
